(ns ycweb.app.website.school.landing.list
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc school < rum/reactive [app-atom]
  (let [state-atom (cmn/action-cursor app-atom)
        courses (cmn/curact state-atom [:courses])
        user (cmn/curact app-atom [:user])]
    (list
      [:main {:id "main-content"}
       [:div.header-banner.u-bg-terracotta
        [:div.header-banner__text-wrapper
         [:div.header-banner__text.u-text-white
          [:h1.header-banner__title
           [:span.header-banner__pretitle "Yuppiechef Online"]
           "Cooking School"]]]

        [:div.header-banner__image-wrapper
         (web-common/lazy-image app-atom
           "pages/cooking-school/landing-page/yuppiechef-online-cooking-school-header-banner"
           {:class ["header-banner__image"]}
           {:w 960
            :mw 490
            :dpr 2
            :q "auto"
            :alt "Yuppiechef Online Cooking School"})]]
       [:div
        {:class (u/bem :yc-section [:medium-underline])}
        [:div.u-block.u-block-center.u-max-width-720.u-text-center
         [:h2
          {:class (u/bem :yc-heading [:center :default])}
          "Yuppiechef Online Cooking School is no longer available"]
         [:p
          {:class (u/bem :yc-paragraph [:medium-large])}
          "After more than a decade since we first launched the Yuppiechef’s Online Cooking School, we’ve made
           the difficult decision to no longer sell Online Cooking School Courses or the Full Access Bundle. Customers
           with existing Yuppiechef Cooking School Courses and Memberships will still have access to their courses for
           the time being."]]]
       [:div
        {:class (u/bem :yc-section [:large :center])}
        [:div.flex-grid-group
         (when (and user (not-empty courses))
           (buttons/button
             "My Courses"
             #(urlstate/redirect app-atom "cooking-school-my-courses")
             {:style :primary}))]
        (toaster/loading-overlay app-atom :web.cooking-school/courses)]])))

(defmethod flow/render-screen :web.cooking-school [app-atom _]
  (website/screen-wrapper app-atom
    (school app-atom)
    {:pagetype :school}))

(defmethod t/transition-open :web.cooking-school [app-atom _ _]
  (toaster/open-overlay app-atom :web.cooking-school/courses)
  (comms/ajax-get :web/cooking-school {})
  (let [user (cmn/curact app-atom [:user])]
    (when user (comms/ajax-get :web.cooking-school/my-courses {}))))

(defmethod comms/receive :web/cooking-school [app-atom e]
  (toaster/close-overlay app-atom :web.cooking-school/courses)
  (swap!
    (cmn/action-cursor app-atom) assoc
    :free-course (:free-course e)))
